(function () {
  'use strict';

  var mobile = function () { return window.matchMedia('(max-width:760px)').matches; };
  var z = 20;
  function win(id) { return document.getElementById('win-' + id); }

  /* ================= windows shit ================= */
  function open(id) {
    var w = win(id);
    if (!w) return;
    if (mobile()) {
      document.querySelectorAll('.win').forEach(function (o) { o.style.display = 'none'; });
    }
    w.style.display = 'flex';
    w.classList.remove('min');
    if (w.querySelector('.body')) w.querySelector('.body').scrollTop = 0;
    focus(id);
  }
  function focus(id) {
    var w = win(id);
    if (!w) return;
    w.style.zIndex = ++z;
    document.querySelectorAll('.win').forEach(function (el) { el.dataset.on = 'false'; });
    w.dataset.on = 'true';
    tasks();
  }
  function close(id) {
    var w = win(id);
    if (w) w.style.display = 'none';
    tasks();
  }
  function minimize(id) {
    var w = win(id);
    if (!w) return;
    if (mobile()) w.style.display = 'none';
    else w.classList.add('min');
    tasks();
  }
  function tasks() {
    var bar = document.getElementById('tasks');
    if (!bar) return;
    bar.innerHTML = '';
    if (mobile()) return;
    document.querySelectorAll('.win').forEach(function (w) {
      if (w.style.display === 'none') return;
      var id = w.id.replace('win-', '');
      var b = document.createElement('div');
      b.className = 'task' + (w.dataset.on === 'true' && !w.classList.contains('min') ? ' on' : '');
      b.textContent = w.querySelector('.ttl').textContent;
      b.onclick = function () {
        if (w.classList.contains('min')) open(id);
        else if (w.dataset.on === 'true') minimize(id);
        else focus(id);
      };
      bar.appendChild(b);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.tbar button');
    if (b) {
      var id = b.closest('.win').id.replace('win-', '');
      if (b.dataset.act === 'close') close(id);
      if (b.dataset.act === 'min') minimize(id);
      return;
    }
    var j = e.target.closest('[data-jump]');
    if (j) { e.preventDefault(); open(j.dataset.jump); }
  });

  document.querySelectorAll('.win').forEach(function (w) {
    var id = w.id.replace('win-', '');
    w.addEventListener('mousedown', function () { focus(id); });
    w.addEventListener('touchstart', function () { focus(id); }, { passive: true });
  });

  /* ================= dragging ================= */
  function dragify(bar) {
    var w = bar.closest('.win');
    var dx = 0, dy = 0, on = false;
    bar.addEventListener('pointerdown', function (e) {
      if (mobile() || e.target.closest('button')) return;
      var r = w.getBoundingClientRect();
      dx = e.clientX - r.left; dy = e.clientY - r.top; on = true;
      w.style.left = r.left + 'px'; w.style.top = r.top + 'px';
      focus(w.id.replace('win-', ''));
      bar.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    bar.addEventListener('pointermove', function (e) {
      if (!on) return;
      w.style.left = Math.max(-40, Math.min(window.innerWidth - 80, e.clientX - dx)) + 'px';
      w.style.top = Math.max(0, Math.min(window.innerHeight - 60, e.clientY - dy)) + 'px';
    });
    function stop(e) {
      if (!on) return;
      on = false;
      try { bar.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    bar.addEventListener('pointerup', stop);
    bar.addEventListener('pointercancel', stop);
  }
  document.querySelectorAll('.win .tbar').forEach(dragify);

  /* ================= icon glyph fallbacks ================= */
  var GLYPH = {
    merch: '\uD83D\uDCC1', cart: '\uD83D\uDED2', mv: '\uD83C\uDFAC',
    listen: '\uD83C\uDFA7', socials: '\uD83C\uDF10', tour: '\uD83D\uDCC5',
    game: '\uD83E\uDDC0', contact: '\uD83D\uDCAC', readme: '\uD83D\uDCC4',
    bin: '\uD83D\uDDD1\uFE0F', instagram: '\uD83D\uDCF7', tiktok: '\uD83C\uDFB5',
    x: '\u2716\uFE0F', youtube: '\u25B6\uFE0F'
  };
  document.querySelectorAll('[data-fb]').forEach(function (el) {
    if (el.querySelector('img')) return;
    var txt = (el.textContent || '').trim();
    if (txt === '' || txt === '*') {
      var g = GLYPH[el.dataset.fb];
      if (g) el.textContent = g;
    }
  });

  /* ================= toast ================= */
  var toast = document.createElement('div');
  toast.id = 'toast';
  toast.innerHTML = '<div class="tt"></div><div class="tx"></div><div class="ta"></div>';
  document.body.appendChild(toast);
  var tmr;
  function say(title, text, actions) {
    toast.querySelector('.tt').textContent = title;
    toast.querySelector('.tx').textContent = text;
    toast.querySelector('.ta').innerHTML = actions || '';
    toast.classList.add('on');
    clearTimeout(tmr);
    tmr = setTimeout(function () { toast.classList.remove('on'); }, actions ? 7000 : 3200);
  }

  /* ================= icons ================= */
  var GUESS = {
    'merch': 'merch', 'shop': 'merch', 'bracelet': 'merch', 'bracelets': 'merch',
    'cart': 'cart', 'bag': 'cart',
    'video': 'mv', 'mv': 'mv', 'bff4l.mp4': 'mv', 'bff4l': 'mv',
    'listen': 'listen', 'music': 'listen', 'songs': 'listen',
    'contact': 'contact', 'message': 'contact', 'dm': 'contact', 'email': 'contact',
    'readme': 'readme', 'readme.txt': 'readme', 'notes': 'readme', 'about': 'readme',
    'bin': 'bin', 'recycle bin': 'bin', 'trash': 'bin', 'recycle': 'bin',
    'socials': 'socials', 'social': 'socials', 'follow': 'socials', 'links': 'socials',
    'tour': 'tour', 'shows': 'tour', 'dates': 'tour', 'tour.txt': 'tour',
    'game': 'game', 'cheese': 'game', 'cheese.exe': 'game', 'play': 'game'
  };

  function resolve(el) {
    var want = (el.dataset.open || '').trim();
    if (want && win(want)) return want;

    var label = (el.textContent || '').trim().toLowerCase();
    if (GUESS[label] && win(GUESS[label])) return GUESS[label];

    for (var key in GUESS) {
      if (label.indexOf(key) > -1 && win(GUESS[key])) return GUESS[key];
    }
    return want || null;
  }

  function launch(el) {
    var id = resolve(el);
    if (id && win(id)) { open(id); return; }
    say('holottaOS', 'That window isn\'t set up yet. In Customize, set this icon\'s "Opens" dropdown.');
  }

  document.querySelectorAll('.icon').forEach(function (ic) {
    ic.addEventListener('click', function () {
      document.querySelectorAll('.icon').forEach(function (o) { o.classList.remove('sel'); });
      ic.classList.add('sel');
      launch(ic);
    });
  });

  /* ================= recycle bin ================= */
  document.querySelectorAll('[data-trash]').forEach(function (f) {
    f.addEventListener('click', function () {
      document.querySelectorAll('.bin .file').forEach(function (o) { o.classList.remove('sel'); });
      f.classList.add('sel');
      say(f.querySelector('.nm').textContent, f.dataset.trash);
    });
  });

  /* ================= media player ================= */
  var slot = document.getElementById('mvslot');
  if (slot) {
    slot.addEventListener('click', function (e) {
      if (!e.target.closest('[data-play]')) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + slot.dataset.yt + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = 'video';
      f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
      f.setAttribute('allowfullscreen', '');
      slot.innerHTML = '';
      slot.appendChild(f);
    });
  }

  /* ================= contact chat bubbles ================= */
  var cform = document.getElementById('cform');
  var thread = document.getElementById('thread');
  if (cform && thread) {
    cform.addEventListener('submit', function () {
      var box = cform.querySelector('textarea');
      if (!box || !box.value.trim()) return;
      var p = document.createElement('p');
      p.className = 'msg me';
      p.textContent = box.value.trim();
      thread.appendChild(p);
    });
  }

  /* ================= keep the cart window in sync ================= */
  function refreshCart() {
    return fetch(window.location.pathname + '?sections=win-cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['win-cart'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#win-cart');
        var live = document.getElementById('win-cart');
        if (!fresh || !live) return;
        var wasOpen = live.style.display;
        var zi = live.style.zIndex;
        var l = live.style.left, t = live.style.top;
        live.innerHTML = fresh.innerHTML;
        live.style.display = wasOpen;
        live.style.zIndex = zi;
        live.style.left = l;
        live.style.top = t;
        wireCart(live);
      })
      .catch(function () {});
  }

  function wireCart(scope) {
    scope.querySelectorAll('.tbar button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.act === 'close') close('cart');
        if (b.dataset.act === 'min') minimize('cart');
      });
    });
    var bar = scope.querySelector('.tbar');
    if (bar) dragify(bar);
  }

  /* ================= add to cart shit ================= */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      var was = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = document.getElementById('cartcount');
          if (c) c.textContent = cart.item_count;
          refreshCart();
          say('Cart', 'Added to your cart.',
            '<button class="btn" data-jump="cart">View cart</button>' +
            '<a class="btn ghost" href="/checkout">Checkout</a>');
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.textContent = was; btn.disabled = false; } }, 1400);
        })
        .catch(function () { f.submit(); });
    });
  });

  /* ================= start menu shit ================= */
  var menu = document.getElementById('startmenu');
  var start = document.getElementById('start');
  if (start && menu) {
    start.addEventListener('click', function (e) { menu.classList.toggle('on'); e.stopPropagation(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#startmenu')) menu.classList.remove('on');
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        menu.classList.remove('on');
        launch(a);
      });
    });
  }

  /* ================= clock ================= */
  var clockEl = document.getElementById('clock');
  function clock() {
    if (!clockEl) return;
    var d = new Date(), h = d.getHours(), m = String(d.getMinutes()).padStart(2, '0');
    var ap = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    clockEl.textContent = h + ':' + m + ' ' + ap;
  }
  clock();
  setInterval(clock, 10000);


  /* ================= cheese game ================= */
  (function () {
    var field = document.getElementById('g-field');
    if (!field) return;

    var scoreEl = document.getElementById('g-score');
    var timeEl = document.getElementById('g-time');
    var startEl = document.getElementById('g-start');
    var goBtn = document.getElementById('g-go');

    var GOAL = parseInt(field.dataset.goal, 10) || 15;
    var SECS = parseInt(field.dataset.seconds, 10) || 30;
    var SPEED = parseInt(field.dataset.speed, 10) || 6;
    var GOOD = field.dataset.good || '🧀';
    var BADS = (field.dataset.bad || '💀').trim().split(/\s+/);

    var score = 0, left = SECS, spawner = null, ticker = null, frames = null, live = [];

    function clearDrops() {
      live.forEach(function (d) { if (d.el.parentNode) d.el.remove(); });
      live = [];
    }

    function end(won) {
      clearInterval(spawner); clearInterval(ticker);
      cancelAnimationFrame(frames);
      clearDrops();
      startEl.style.display = 'grid';
      var code = (field.dataset.code || '').trim();
      if (won && code) {
        startEl.innerHTML =
          '<p class="g-title">' + field.dataset.win + '</p>' +
          '<span class="g-code">' + code + '</span>' +
          '<button class="btn" id="g-go">PLAY AGAIN</button>';
      } else if (won) {
        startEl.innerHTML =
          '<p class="g-title">' + field.dataset.win + '</p>' +
          '<p class="g-sub">(no code set yet)</p>' +
          '<button class="btn" id="g-go">PLAY AGAIN</button>';
      } else {
        startEl.innerHTML =
          '<p class="g-title">' + field.dataset.lose + '</p>' +
          '<p class="g-sub">you got ' + score + ' of ' + GOAL + '</p>' +
          '<button class="btn" id="g-go">TRY AGAIN</button>';
      }
      document.getElementById('g-go').addEventListener('click', start);
    }

    function pop(x, y, txt) {
      var s = document.createElement('span');
      s.className = 'pop';
      s.textContent = txt;
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      field.appendChild(s);
      var t = 0;
      (function fade() {
        t += 0.06;
        s.style.transform = 'translateY(' + (-t * 30) + 'px)';
        s.style.opacity = String(1 - t);
        if (t < 1) requestAnimationFrame(fade); else s.remove();
      })();
    }

    function spawn() {
      var good = Math.random() < 0.62;
      var el = document.createElement('span');
      el.className = 'drop';
      el.textContent = good ? GOOD : BADS[Math.floor(Math.random() * BADS.length)];
      el.style.left = Math.random() * (field.clientWidth - 40) + 'px';
      field.appendChild(el);

      var d = { el: el, y: -40, vy: 1.4 + Math.random() * (SPEED / 3), good: good, dead: false };

      function hit(e) {
        e.preventDefault();
        e.stopPropagation();
        if (d.dead) return;
        d.dead = true;
        var r = el.getBoundingClientRect(), f = field.getBoundingClientRect();
        if (good) { score++; pop(r.left - f.left, r.top - f.top, '+1'); }
        else { score = Math.max(0, score - 2); pop(r.left - f.left, r.top - f.top, '-2'); }
        scoreEl.textContent = score;
        el.remove();
        if (score >= GOAL) end(true);
      }
      el.addEventListener('pointerdown', hit);
      live.push(d);
    }

    function step() {
      var h = field.clientHeight;
      live = live.filter(function (d) {
        if (d.dead) return false;
        d.y += d.vy;
        d.el.style.transform = 'translateY(' + d.y + 'px)';
        if (d.y > h + 40) { d.el.remove(); return false; }
        return true;
      });
      frames = requestAnimationFrame(step);
    }

    function start() {
      score = 0; left = SECS;
      scoreEl.textContent = '0';
      timeEl.textContent = left;
      startEl.style.display = 'none';
      clearDrops();

      spawner = setInterval(spawn, Math.max(260, 1100 - SPEED * 85));
      ticker = setInterval(function () {
        left--;
        timeEl.textContent = left;
        if (left <= 0) end(score >= GOAL);
      }, 1000);
      frames = requestAnimationFrame(step);
    }

    if (goBtn) goBtn.addEventListener('click', start);
  })();

  /* ================= theme editor ================= */
  if (window.Shopify && window.Shopify.designMode) {
    // clicking a section or block in the customizer opens that window
    function reveal(el) {
      var w = el && el.closest ? el.closest('.win') : null;
      if (w) open(w.id.replace('win-', ''));
    }
    document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
    document.addEventListener('shopify:block:select', function (e) { reveal(e.target); });
  }

  /* ================= start up ================= */
  document.querySelectorAll('.win').forEach(function (w) { w.style.display = 'none'; });

  var cls = document.body.className;
  var first = 'merch';
  if (cls.indexOf('template-cart') > -1) first = 'cart';

  if (window.location.hash) {
    var h = window.location.hash.replace('#', '');
    if (win(h)) first = h;
  }

  open(first);
  tasks();
  requestAnimationFrame(function () { document.body.classList.add('ready'); });

  window.addEventListener('resize', function () {
    if (mobile()) {
      document.querySelectorAll('.win').forEach(function (w) { w.style.left = ''; w.style.top = ''; });
    }
  });
})();
